import { defineMessages } from 'react-intl';

export const MeterList = defineMessages({
  meterList: {
    id: 'app.common.meterList',
    defaultMessage: 'Seznam měřidel',
  },
});

export const MeterListContent = defineMessages({
  table: {
    id: 'app.common.table',
    defaultMessage: 'Tabulka',
  },
  map: {
    id: 'app.common.map',
    defaultMessage: 'Mapa',
  },
});

export const MarkerTooltip = defineMessages({
  serialNumber: {
    id: 'app.common.serialNumberShortcut',
    defaultMessage: 'VČ {serialNumber}',
  },
});

export const Columns = defineMessages({
  monitoredEntity: {
    id: 'app.common.monitoredEntity',
    defaultMessage: 'Název měřidla',
  },
  serialNumber: {
    id: 'app.common.serialNumber',
    defaultMessage: 'Sériové číslo',
  },
  building: {
    id: 'app.common.building',
    defaultMessage: 'Budova',
  },
  floor: {
    id: 'app.common.floor',
    defaultMessage: 'Podlaží',
  },
  lastUpdate: {
    id: 'app.common.lastUpdate',
    defaultMessage: 'Poslední aktualizace',
  },
  action: {
    id: 'app.common.action',
    defaultMessage: 'Akce',
  },
  commodity: {
    id: 'app.common.commodity',
  },
});
